var map = {
	"./countries": 77113,
	"./countries.json": 77113,
	"./countries/abw.svg": 78855,
	"./countries/afg.svg": 45698,
	"./countries/ago.svg": 86637,
	"./countries/aia.svg": 57184,
	"./countries/ala.svg": 29062,
	"./countries/alb.svg": 60661,
	"./countries/and.svg": 86405,
	"./countries/are.svg": 4305,
	"./countries/arg.svg": 68297,
	"./countries/arm.svg": 19090,
	"./countries/asm.svg": 53203,
	"./countries/ata.svg": 876,
	"./countries/atf.svg": 57671,
	"./countries/atg.svg": 11183,
	"./countries/aus.svg": 25864,
	"./countries/aut.svg": 14728,
	"./countries/aze.svg": 45437,
	"./countries/bdi.svg": 22386,
	"./countries/bel.svg": 18476,
	"./countries/ben.svg": 19273,
	"./countries/bes.svg": 76126,
	"./countries/bfa.svg": 96505,
	"./countries/bgd.svg": 3220,
	"./countries/bgr.svg": 89672,
	"./countries/bhr.svg": 64847,
	"./countries/bhs.svg": 42430,
	"./countries/bih.svg": 51389,
	"./countries/blm.svg": 64339,
	"./countries/blr.svg": 28895,
	"./countries/blz.svg": 54710,
	"./countries/bmu.svg": 20886,
	"./countries/bol.svg": 13923,
	"./countries/bra.svg": 8581,
	"./countries/brb.svg": 89552,
	"./countries/brn.svg": 93849,
	"./countries/btn.svg": 63579,
	"./countries/bvt.svg": 13011,
	"./countries/bwa.svg": 38064,
	"./countries/caf.svg": 73288,
	"./countries/can.svg": 56053,
	"./countries/cat.svg": 35423,
	"./countries/cck.svg": 52633,
	"./countries/che.svg": 13015,
	"./countries/chl.svg": 41685,
	"./countries/chn.svg": 18294,
	"./countries/civ.svg": 11928,
	"./countries/cmr.svg": 96596,
	"./countries/cod.svg": 28549,
	"./countries/cog.svg": 33258,
	"./countries/cok.svg": 25213,
	"./countries/col.svg": 41632,
	"./countries/com.svg": 64787,
	"./countries/cpv.svg": 20072,
	"./countries/cri.svg": 87976,
	"./countries/cub.svg": 48071,
	"./countries/cuw.svg": 54134,
	"./countries/cxr.svg": 19330,
	"./countries/cym.svg": 83602,
	"./countries/cyp.svg": 32249,
	"./countries/cze.svg": 97092,
	"./countries/deu.svg": 91778,
	"./countries/dji.svg": 23838,
	"./countries/dma.svg": 62615,
	"./countries/dnk.svg": 29177,
	"./countries/dom.svg": 14749,
	"./countries/dza.svg": 13599,
	"./countries/ecu.svg": 58656,
	"./countries/egy.svg": 99715,
	"./countries/eng.svg": 62553,
	"./countries/eri.svg": 24138,
	"./countries/esh.svg": 25963,
	"./countries/esp.svg": 93627,
	"./countries/est.svg": 67544,
	"./countries/eth.svg": 44393,
	"./countries/eun.svg": 21174,
	"./countries/fin.svg": 3389,
	"./countries/fji.svg": 54502,
	"./countries/flk.svg": 983,
	"./countries/fra.svg": 78853,
	"./countries/fro.svg": 77128,
	"./countries/fsm.svg": 60751,
	"./countries/gab.svg": 370,
	"./countries/gbr.svg": 90356,
	"./countries/geo.svg": 70234,
	"./countries/ggy.svg": 93789,
	"./countries/gha.svg": 1766,
	"./countries/gib.svg": 71075,
	"./countries/gin.svg": 12086,
	"./countries/glp.svg": 54352,
	"./countries/gmb.svg": 42444,
	"./countries/gnb.svg": 26251,
	"./countries/gnq.svg": 26157,
	"./countries/grc.svg": 56544,
	"./countries/grd.svg": 95222,
	"./countries/grl.svg": 64742,
	"./countries/gtm.svg": 20543,
	"./countries/guf.svg": 29454,
	"./countries/gum.svg": 41618,
	"./countries/guy.svg": 27497,
	"./countries/hkg.svg": 23672,
	"./countries/hmd.svg": 49972,
	"./countries/hnd.svg": 86136,
	"./countries/hrv.svg": 58652,
	"./countries/hti.svg": 35716,
	"./countries/hun.svg": 30993,
	"./countries/idn.svg": 92792,
	"./countries/imn.svg": 62690,
	"./countries/ind.svg": 40594,
	"./countries/iot.svg": 14236,
	"./countries/irl.svg": 74461,
	"./countries/irn.svg": 56301,
	"./countries/irq.svg": 10313,
	"./countries/isl.svg": 85054,
	"./countries/isr.svg": 87983,
	"./countries/ita.svg": 995,
	"./countries/jam.svg": 13143,
	"./countries/jey.svg": 17689,
	"./countries/jor.svg": 34432,
	"./countries/jpn.svg": 9995,
	"./countries/kaz.svg": 89675,
	"./countries/ken.svg": 18351,
	"./countries/kgz.svg": 75368,
	"./countries/khm.svg": 68668,
	"./countries/kir.svg": 6905,
	"./countries/kna.svg": 7057,
	"./countries/kor.svg": 20240,
	"./countries/kos.svg": 27282,
	"./countries/kwt.svg": 46033,
	"./countries/lao.svg": 82233,
	"./countries/lbn.svg": 4605,
	"./countries/lbr.svg": 80197,
	"./countries/lby.svg": 84739,
	"./countries/lca.svg": 92968,
	"./countries/lie.svg": 58801,
	"./countries/lka.svg": 28240,
	"./countries/lso.svg": 20457,
	"./countries/ltu.svg": 93748,
	"./countries/lux.svg": 54158,
	"./countries/lva.svg": 68867,
	"./countries/mac.svg": 62399,
	"./countries/maf.svg": 18961,
	"./countries/mar.svg": 81288,
	"./countries/mco.svg": 65925,
	"./countries/mda.svg": 34442,
	"./countries/mdg.svg": 7987,
	"./countries/mdv.svg": 12081,
	"./countries/mex.svg": 37218,
	"./countries/mhl.svg": 8645,
	"./countries/mkd.svg": 2659,
	"./countries/mli.svg": 78337,
	"./countries/mlt.svg": 54228,
	"./countries/mmr.svg": 851,
	"./countries/mne.svg": 54008,
	"./countries/mng.svg": 6677,
	"./countries/mnp.svg": 41729,
	"./countries/moz.svg": 55867,
	"./countries/mrt.svg": 22254,
	"./countries/msr.svg": 93681,
	"./countries/mtq.svg": 7519,
	"./countries/mus.svg": 29288,
	"./countries/mwi.svg": 14848,
	"./countries/mys.svg": 33550,
	"./countries/myt.svg": 35613,
	"./countries/nam.svg": 93653,
	"./countries/ncl.svg": 33764,
	"./countries/ner.svg": 2413,
	"./countries/nfk.svg": 30766,
	"./countries/nga.svg": 46782,
	"./countries/nic.svg": 46132,
	"./countries/nir.svg": 18702,
	"./countries/niu.svg": 24166,
	"./countries/nld.svg": 1564,
	"./countries/nor.svg": 50645,
	"./countries/npl.svg": 51531,
	"./countries/nru.svg": 64666,
	"./countries/nzl.svg": 83312,
	"./countries/omn.svg": 29397,
	"./countries/pak.svg": 2474,
	"./countries/pan.svg": 23284,
	"./countries/pcn.svg": 44588,
	"./countries/per.svg": 68634,
	"./countries/phl.svg": 27119,
	"./countries/plw.svg": 33717,
	"./countries/png.svg": 36670,
	"./countries/pol.svg": 31078,
	"./countries/pri.svg": 5085,
	"./countries/prk.svg": 33257,
	"./countries/prt.svg": 98306,
	"./countries/pry.svg": 28410,
	"./countries/pse.svg": 64776,
	"./countries/pyf.svg": 47544,
	"./countries/qat.svg": 19517,
	"./countries/reu.svg": 56909,
	"./countries/rou.svg": 23801,
	"./countries/rus.svg": 24056,
	"./countries/rwa.svg": 90301,
	"./countries/sau.svg": 50485,
	"./countries/sco.svg": 31540,
	"./countries/sdn.svg": 20556,
	"./countries/sen.svg": 85806,
	"./countries/sgp.svg": 15286,
	"./countries/sgs.svg": 20680,
	"./countries/shn.svg": 32887,
	"./countries/sjm.svg": 97017,
	"./countries/slb.svg": 89546,
	"./countries/sle.svg": 49974,
	"./countries/slv.svg": 19342,
	"./countries/smr.svg": 41918,
	"./countries/som.svg": 50232,
	"./countries/spm.svg": 49997,
	"./countries/srb.svg": 208,
	"./countries/ssd.svg": 20470,
	"./countries/stp.svg": 83060,
	"./countries/sun.svg": 54978,
	"./countries/sur.svg": 98091,
	"./countries/svk.svg": 3339,
	"./countries/svn.svg": 6302,
	"./countries/swe.svg": 96051,
	"./countries/swz.svg": 11098,
	"./countries/sxm.svg": 10954,
	"./countries/syc.svg": 92915,
	"./countries/syr.svg": 2602,
	"./countries/tca.svg": 37213,
	"./countries/tcd.svg": 61433,
	"./countries/tgo.svg": 17807,
	"./countries/tha.svg": 83891,
	"./countries/tjk.svg": 13430,
	"./countries/tkl.svg": 86056,
	"./countries/tkm.svg": 47978,
	"./countries/tls.svg": 7870,
	"./countries/ton.svg": 34352,
	"./countries/tto.svg": 45350,
	"./countries/tun.svg": 12223,
	"./countries/tur.svg": 66258,
	"./countries/tuv.svg": 90183,
	"./countries/twn.svg": 6259,
	"./countries/tza.svg": 83058,
	"./countries/uga.svg": 26254,
	"./countries/ukr.svg": 66344,
	"./countries/umi.svg": 96026,
	"./countries/ury.svg": 16701,
	"./countries/usa.svg": 52903,
	"./countries/uzb.svg": 72555,
	"./countries/vat.svg": 46707,
	"./countries/vct.svg": 87848,
	"./countries/ven.svg": 5312,
	"./countries/vgb.svg": 21283,
	"./countries/vir.svg": 88262,
	"./countries/vnm.svg": 40258,
	"./countries/vut.svg": 55273,
	"./countries/wal.svg": 36570,
	"./countries/wlf.svg": 54954,
	"./countries/wsm.svg": 40113,
	"./countries/yem.svg": 4972,
	"./countries/zaf.svg": 87362,
	"./countries/zmb.svg": 73145,
	"./countries/zwe.svg": 39072,
	"./country": 5890,
	"./country.json": 5890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65207;